export const WalletStatus = {
  ACTIVE: "active",
  CLOSED: "closed",
} as const;
export type WalletStatus = (typeof WalletStatus)[keyof typeof WalletStatus];
